import axios from "axios";
import * as React from "react";
import { useEffect, useState } from "react";
import HallSessions from "./HallSessions";

export const PRE_HALL: Array<ProgrammeSession["hall"]> = ["Pre-Congress"];
export const HALL_CATEGORY_1: Array<ProgrammeSession["hall"]> = ["Hall A"];
export const HALL_CATEGORY_2: Array<ProgrammeSession["hall"]> = ["Hall B"];
export const HALL_CATEGORY_3: Array<ProgrammeSession["hall"]> = ["Hall C"];
export const HALL_CATEGORY_4: Array<ProgrammeSession["hall"]> = ["Hall D"];
export const HALL_CATEGORY_5: Array<ProgrammeSession["hall"]> = ["Hall E"];

const EVENT_DATES = [
    { dayNum: 0, dayName: "Pre-Congress Workshop", date: "16 July 2025" },
    { dayNum: 1, dayName: "1st Day", date: "17 July 2025" },
    { dayNum: 2, dayName: "2nd Day", date: "18 July 2025" },
    { dayNum: 3, dayName: "3rd Day", date: "19 July 2025" },
];

export const FACULTY_TYPE = [
    "Chairperson",
    "Citation",
    "Co-Chair",
    "Emcee",
    "Judge",
    "Guest Of Honor",
    "Speaker",
    "Adjudicator",
    "Surgeon",
    "Panel",
    "Moderator",
    "Facilitator",
    "Facilitators",
] as const;

export enum CATEGORY {
    "pre_hall",
    "hall_a",
    "hall_b",
    "hall_c",
    "hall_d",
    "hall_e",
}

export interface Faculty {
    id: number;
    fullName: string;
    avatar: string;
    shortProfile: string;
}

export interface FacultyWithType extends Faculty {
    facultyType: (typeof FACULTY_TYPE)[number];
}

export interface ProgrammeSession {
    id: number;
    title: string;
    desc?: string;
    startAt: string;
    endAt: string;
    date: string; // 11 JUN | SATURDAY
    time: string; // 10:00 to 11:00
    day: 0 | 1 | 2 | 3;
    hallOverwrite?: string;
    hall: "Pre-Congress" | "Hall A" | "Hall B" | "Hall C" | "Hall D" | "Hall E";
    category: "hall_a" | "hall_b" | "hall_c" | "hall_d" | "hall_e";
    faculties: Array<FacultyWithType>;
    subsessions: Array<ProgrammeSubsession>;
    secondsTillStart: number;
    durationInSeconds: number;
    ended?: boolean;
}

export interface ProgrammeSubsession {
    id: number;
    title?: string;
    description?: string;
    speakers: Array<Faculty>;
    time: string; // 10:00 to 11:00
}

const Programme = ({ defaultDay }) => {
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState<CATEGORY>(CATEGORY.pre_hall);
    const [day, setDay] = useState(defaultDay || 0);
    const [data, setData] = useState([]);

    const [activeLecture, setActiveLecture] = useState<ProgrammeSession["hall"]>("Pre-Congress");

    useEffect(() => {
        setLoading(true);
        axios
            .get(`/api/programme_sessions?category=${CATEGORY[category]}&day=${day}`)
            .then((response) => {
                setData(response.data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [day, category]);

    const dayClass = "btn btn-outline-navy my-1 fw-bold me-2";
    const catClass = "btn btn-outline-red my-1 fw-bold me-2";
    // const dayClass = "d-inline-block theme-btn py-1";
    // const catClass = "d-inline-block theme-btn theme-btn-orange rounded-0 py-1";

    const getTabColor = (hallname: string) => {
        switch (hallname) {
            case "Hall A":
                return "#9BC34A";
            case "Hall B":
                return "#F44336";
            case "Hall C":
                return "#4CAF50";
            case "Hall D":
                return "#2196F3";
            case "Hall E":
                return "#9C27B0";
            default:
                return "#FFC107";
        }
    };

    if (loading) {
        return (
            <div className="loader">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <div className="container pb-5" id="programmeAgenda">
            <div className="filterBtns">
                {/* 1st row */}
                <div className="d-flex flex-wrap justify-content-center gap-2 my-3">
                    {EVENT_DATES.map(({ dayNum, dayName, date }) => (
                        <button
                            key={dayNum}
                            className={`${dayNum === day && "active"} ${dayClass}`}
                            onClick={() => {
                                setDay(dayNum);
                                if (dayNum === 0) {
                                    setCategory(CATEGORY.pre_hall);
                                    setActiveLecture("Pre-Congress");
                                }
                                if (dayNum === 1 || dayNum === 2 || dayNum === 3) {
                                    setCategory(CATEGORY.hall_a);
                                    setActiveLecture("Hall A");
                                }
                                // else if (dayNum === 'pre_1' || dayNum === 'pre_2') {
                                //   setCategory(CATEGORY.eha_pre_tutorial);
                                //   setActiveLecture('EHA Pre-Congress Tutorial');
                                // }
                            }}
                        >
                            <div>{dayName}</div>
                            <div>{date}</div>
                        </button>
                    ))}
                </div>

                {/* 2nd row */}

                {day === 1 && (
                    <div className="d-flex flex-wrap justify-content-center gap-2 my-3">
                        <button
                            className={`${category === CATEGORY.hall_a && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_a);
                                setActiveLecture("Hall A");
                            }}
                        >
                            <div>Hall A</div>
                            <div>Tamingsari 3 (ISS PNU)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_b && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_b);
                                setActiveLecture("Hall B");
                            }}
                        >
                            <div>Hall B</div>
                            <div>Tamingsari 2 (MSN 1)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_c && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_c);
                                setActiveLecture("Hall C");
                            }}
                        >
                            <div>Hall C</div>
                            <div>Tamingsari 1 (MSN 2)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_d && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_d);
                                setActiveLecture("Hall D");
                            }}
                        >
                            <div>Hall D</div>
                            <div>Tun Sri Lanang 1 & 2 (BNC)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_e && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_e);
                                setActiveLecture("Hall E");
                            }}
                        >
                            <div>CCNDP Interactive Workshop</div>
                        </button>
                    </div>
                )}

                {(day === 2 || day === 3) && (
                    <div className="d-flex flex-wrap justify-content-center gap-2 my-3">
                        <button
                            className={`${category === CATEGORY.hall_a && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_a);
                                setActiveLecture("Hall A");
                            }}
                        >
                            <div>Hall A</div>
                            <div>Tamingsari 3 (ISS PNU)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_b && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_b);
                                setActiveLecture("Hall B");
                            }}
                        >
                            <div>Hall B</div>
                            <div>Tamingsari 2 (MSN 1)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_c && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_c);
                                setActiveLecture("Hall C");
                            }}
                        >
                            <div>Hall C</div>
                            <div>Tamingsari 1 (MSN 2)</div>
                        </button>

                        <button
                            className={`${category === CATEGORY.hall_d && "active"} ${catClass}`}
                            onClick={() => {
                                setCategory(CATEGORY.hall_d);
                                setActiveLecture("Hall D");
                            }}
                        >
                            <div>Hall D</div>
                            <div>Tun Sri Lanang 1 & 2 (BNC)</div>
                        </button>
                    </div>
                )}

                {/* 3rd row */}
                <div className="col-12 col-lg-8 mx-auto">
                    {category === CATEGORY.pre_hall && (
                        <div className="mt-5">
                            <div className="d-block d-md-none">
                                {PRE_HALL.map((hall) => {
                                    let hallName = hall.replace("Lecture ", "");
                                    if (hallName === "Pre-Congress") {
                                        hallName = "Hospital Sultan Abdul Aziz Shah, UPM";
                                    }
                                    return (
                                        <button
                                            key={hall}
                                            className={`hallTabs fw-bold ${activeLecture !== hall && "deselected"}`}
                                            style={{
                                                background: getTabColor(hall),
                                                textTransform: "capitalize",
                                            }}
                                            onClick={() => setActiveLecture(hall)}
                                        >
                                            {hallName}
                                        </button>
                                    );
                                })}
                            </div>

                            <div className="row nogutters">
                                {PRE_HALL.map((hall) => (
                                    // <div className={day === 2 ? "col-md-6" : "col-md-4 px-2"} key={hall}>
                                    <div key={hall}>
                                        <HallSessions
                                            hallName={"Pre-Congress"}
                                            activeHall={activeLecture}
                                            programmes={data.filter(
                                                (programme: ProgrammeSession) => programme.hall === hall
                                            )}
                                            getTabColor={getTabColor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {category === CATEGORY.hall_a && (
                        <div className="mt-5">
                            <div className="d-block d-md-none">
                                {HALL_CATEGORY_1.map((hall) => (
                                    <button
                                        key={hall}
                                        className={`hallTabs fw-bold ${activeLecture !== hall && "deselected"}`}
                                        style={{
                                            background: getTabColor(hall),
                                            textTransform: "capitalize",
                                        }}
                                        onClick={() => setActiveLecture(hall)}
                                    >
                                        {hall.replace("Lecture ", "")}
                                    </button>
                                ))}
                            </div>

                            <div className="row nogutters">
                                {HALL_CATEGORY_1.map((hall) => (
                                    // <div className={day === 2 ? "col-md-6" : "col-md-4 px-2"} key={hall}>
                                    <div key={hall}>
                                        <HallSessions
                                            hallName={hall}
                                            activeHall={activeLecture}
                                            programmes={data.filter(
                                                (programme: ProgrammeSession) => programme.hall === hall
                                            )}
                                            getTabColor={getTabColor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {category === CATEGORY.hall_b && (
                        <div className="mt-5">
                            <div className="d-block d-md-none">
                                {HALL_CATEGORY_2.map((hall) => (
                                    <button
                                        key={hall}
                                        className={`hallTabs fw-bold ${activeLecture !== hall && "deselected"}`}
                                        style={{
                                            background: getTabColor(hall),
                                            textTransform: "capitalize",
                                        }}
                                        onClick={() => setActiveLecture(hall)}
                                    >
                                        {hall.replace("Lecture ", "")}
                                    </button>
                                ))}
                            </div>
                            <div className="row nogutters">
                                {HALL_CATEGORY_2.map((hall) => (
                                    <div key={hall}>
                                        <HallSessions
                                            hallName={hall}
                                            activeHall={activeLecture}
                                            programmes={data.filter(
                                                (programme: ProgrammeSession) => programme.hall === hall
                                            )}
                                            getTabColor={getTabColor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {category === CATEGORY.hall_c && (
                        <div className="mt-5">
                            <div className="d-block d-md-none">
                                {HALL_CATEGORY_3.map((hall) => (
                                    <button
                                        key={hall}
                                        className={`hallTabs fw-bold ${activeLecture !== hall && "deselected"}`}
                                        style={{
                                            background: getTabColor(hall),
                                            textTransform: "capitalize",
                                        }}
                                        onClick={() => setActiveLecture(hall)}
                                    >
                                        {hall.replace("Lecture ", "")}
                                    </button>
                                ))}
                            </div>
                            <div className="row nogutters">
                                {HALL_CATEGORY_3.map((hall) => (
                                    <div key={hall}>
                                        <HallSessions
                                            hallName={hall}
                                            activeHall={activeLecture}
                                            programmes={data.filter(
                                                (programme: ProgrammeSession) => programme.hall === hall
                                            )}
                                            getTabColor={getTabColor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {category === CATEGORY.hall_d && (
                        <div className="mt-5">
                            <div className="d-block d-md-none">
                                {HALL_CATEGORY_4.map((hall) => (
                                    <button
                                        key={hall}
                                        className={`hallTabs fw-bold ${activeLecture !== hall && "deselected"}`}
                                        style={{
                                            background: getTabColor(hall),
                                            textTransform: "capitalize",
                                        }}
                                        onClick={() => setActiveLecture(hall)}
                                    >
                                        {hall.replace("Lecture ", "")}
                                    </button>
                                ))}
                            </div>
                            <div className="row nogutters">
                                {HALL_CATEGORY_4.map((hall) => (
                                    <div key={hall}>
                                        <HallSessions
                                            hallName={hall}
                                            activeHall={activeLecture}
                                            programmes={data.filter(
                                                (programme: ProgrammeSession) => programme.hall === hall
                                            )}
                                            getTabColor={getTabColor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {category === CATEGORY.hall_e && (
                        <div className="mt-5">
                            <div className="d-block d-md-none">
                                {HALL_CATEGORY_5.map((hall) => (
                                    <button
                                        key={hall}
                                        className={`hallTabs fw-bold ${activeLecture !== hall && "deselected"}`}
                                        style={{
                                            background: getTabColor(hall),
                                            textTransform: "capitalize",
                                        }}
                                        onClick={() => setActiveLecture(hall)}
                                    >
                                        {hall.replace("Lecture ", "")}
                                    </button>
                                ))}
                            </div>
                            <div className="row nogutters">
                                {HALL_CATEGORY_5.map((hall) => (
                                    <div key={hall}>
                                        <HallSessions
                                            hallName={hall}
                                            activeHall={activeLecture}
                                            programmes={data.filter(
                                                (programme: ProgrammeSession) => programme.hall === hall
                                            )}
                                            getTabColor={getTabColor}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Programme;
